import { API_RESPONSE_CODE } from "@kivunova/kivufrontendcommon";

/** Role from Identity; used to restrict admin portal to super admins only. */
export const SUPER_ADMIN_ROLES = [
  "PRIMARY_SUPER_ADMIN",
  "SECONDARY_SUPER_ADMIN",
] as const;
export type SuperAdminRole = (typeof SUPER_ADMIN_ROLES)[number];

export function isSuperAdminRole(role: string | null | undefined): boolean {
  return role != null && SUPER_ADMIN_ROLES.includes(role as SuperAdminRole);
}

/** Map role enum to display label (e.g. PRIMARY_SUPER_ADMIN -> "Primary Super Admin"). */
const ROLE_DISPLAY_LABELS: Record<string, string> = {
  PRIMARY_SUPER_ADMIN: "Primary Super Admin",
  SECONDARY_SUPER_ADMIN: "Secondary Super Admin",
  COMPANY_ADMIN: "Company Admin",
  STORE_ADMIN: "Store Admin",
};

export function formatRoleForDisplay(role: string | null | undefined): string {
  if (role == null || role === "") return "";
  return (
    ROLE_DISPLAY_LABELS[role] ??
    role
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export interface AuthorizeResponse {
  authorize: {
    code: string;
    authorized: boolean;
    userId?: string;
    role?: string;
    companyId?: string;
    storeId?: string;
    accessToken?: string;
    refreshToken?: string;
  };
}

export interface AuthorizeRequest {
  accessToken: string;
  refreshToken: string;
}

export interface LogoutResponse {
  logout: {
    code: API_RESPONSE_CODE;
  };
}
